
        Component.define('page-prices', (el, params) => {
            
        });